import React from 'react';
import { faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function DownloadableImage({ imageUrl, imageAlt = 'Photo', onDownload }) {
  const handleImageClick = () => {
    window.open(imageUrl, '_blank');
  };

  return (
    <div className="tw-relative tw-w-32 tw-cursor-pointer tw-group tw-inline-block">
      <img
        src={imageUrl}
        alt={imageAlt}
        onClick={handleImageClick}
        className="tw-w-full tw-h-auto tw-object-contain tw-rounded-[3px] tw-border-[1px] tw-border-solid tw-border-border-primary-strong tw-transition-opacity hover:tw-opacity-80"
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.parentNode.innerHTML =
            '<div class="tw-w-full tw-h-full tw-bg-gray-100 tw-flex tw-items-center tw-justify-center tw-text-gray-400 tw-text-xs tw-rounded-[3px] tw-border-[1px] tw-border-solid tw-border-border-primary-strong">Image</div>';
        }}
      />
      <div className="tw-absolute tw-top-1 tw-right-1 tw-flex tw-gap-1 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity">
        {onDownload && (
          <button
            className="tw-bg-white tw-rounded-full tw-p-1.5 tw-shadow-md hover:tw-shadow-lg tw-transition-shadow tw-border-none tw-cursor-pointer tw-flex tw-items-center tw-justify-center"
            onClick={(e) => {
              e.stopPropagation();
              onDownload();
            }}
            title="Télécharger l'image"
          >
            <FontAwesomeIcon
              icon={faFileDownload}
              className="tw-text-gray-600 tw-w-3 tw-h-3"
            />
          </button>
        )}
      </div>
    </div>
  );
}

export default DownloadableImage;
